export var COMMENT = 'comment';
export var NOTELINK = 'NOTELINK';
export var MENTION = 'MENTION';
export var EMOJI = 'EMOJI';
export var LINK = 'LINK';
export var LINE_BREAK = 'LINE_BREAK';
export var PLACEHOLDER = 'PLACEHOLDER';
export default {
  COMMENT: COMMENT,
  NOTELINK: NOTELINK,
  MENTION: MENTION,
  EMOJI: EMOJI,
  LINK: LINK,
  LINE_BREAK: LINE_BREAK,
  PLACEHOLDER: PLACEHOLDER
};